import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator } from 'lucide-react';
import { TOOLS, CATEGORIES } from '@/lib/tools';

const legalLinks = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/cookie-policy', label: 'Cookie Policy' },
  { to: '/terms', label: 'Terms & Conditions' },
  { to: '/advertising', label: 'Advertising' },
];

const companyLinks = [
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact' },
  { to: '/tools', label: 'All Tools' },
  { to: '/categories', label: 'Categories' },
];

export default function Footer() {
  const featured = TOOLS.slice(0, 6);
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-emerald-600 text-white flex items-center justify-center">
                <Calculator className="w-5 h-5" />
              </div>
              <div className="text-lg font-bold text-white">CalculateEasy</div>
            </Link>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Free, accurate calculators built for the way people actually use them — fast, mobile-friendly, and never in the way of your work.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">Popular tools</h4>
            <ul className="space-y-2 text-sm">
              {featured.map((t) => (
                <li key={t.slug}>
                  <Link to={`/tools/${t.slug}`} className="text-slate-400 hover:text-emerald-400 transition-colors">
                    {t.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">Categories</h4>
            <ul className="space-y-2 text-sm">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link to={`/categories#${c.id}`} className="text-slate-400 hover:text-emerald-400 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">Company</h4>
            <ul className="space-y-2 text-sm">
              {companyLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-slate-400 hover:text-emerald-400 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="text-white font-semibold mt-6 mb-3 text-sm">Legal</h4>
            <ul className="space-y-2 text-sm">
              {legalLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-slate-400 hover:text-emerald-400 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} CalculateEasy. All calculators for informational use only.</div>
          <div>Not professional financial, legal, tax, or medical advice.</div>
        </div>
      </div>
    </footer>
  );
}
